import './App.css';
import { useRoutes } from 'react-router-dom';
import routes from './router/index.js';

const App = () => {
  const element = useRoutes(routes);
  return (
    <div className="app-container">
      {element}
    </div>
  );
}

export default App;
